import moment from "moment";

export const formatDateWithTimezone = (dateString: string) => {
    const date = moment(dateString);
    const timezoneAbbr = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Map common timezones to their abbreviations
    const timezoneMap: { [key: string]: string } = {
        'America/Los_Angeles': 'PST',
        'America/New_York': 'EST',
        'America/Chicago': 'CST',
        'America/Denver': 'MST',
        'America/Phoenix': 'MST',
        'America/Anchorage': 'AKST',
        'Pacific/Honolulu': 'HST',
        'America/Indiana/Indianapolis': 'EST',
        'America/Indiana/Vincennes': 'EST',
        'America/Indiana/Winamac': 'EST',
        'America/Indiana/Marengo': 'EST',
        'America/Indiana/Petersburg': 'EST',
        'America/Indiana/Vevay': 'EST',
        'America/Indiana/Tell_City': 'CST',
        'America/Indiana/Knox': 'CST',
        'America/Menominee': 'CST',
        'America/North_Dakota/Center': 'CST',
        'America/North_Dakota/New_Salem': 'CST',
        'America/North_Dakota/Beulah': 'CST',
        'America/Boise': 'MST',
        'America/Vancouver': 'PST',
        'America/Tijuana': 'PST'
    };

    const timezoneShort = timezoneMap[timezoneAbbr] || timezoneAbbr.split('/').pop()?.substring(0, 3).toUpperCase() || timezoneAbbr;
    return `${date.format('MM/DD/YYYY HH:mm:ss')} ${timezoneShort}`;
};

export const formatShiftTime = (time: string) => {
    if (!time) return '';
    // Handle both HH:mm:ss and HH:mm formats
    const formatted = moment(time, ['HH:mm:ss', 'HH:mm']).format('hh:mm A');
    return formatted !== 'Invalid date' ? formatted : time;
};
